
import ReactDOM from "react-dom/client";
// react library for routing
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { I18nProvider } from './i18n/context';

// plugins styles from node_modules
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/css/App.css";
import "assets/css/InvoiceReceiptstyles.css";
import "quill/dist/quill.core.css";
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "select2/dist/css/select2.min.css";
import "sweetalert2/dist/sweetalert2.min.css";
// plugins styles downloaded
import "assets/vendor/nucleo/css/nucleo.css";
// core styles
import "assets/scss/argon-dashboard-pro-react.scss?v1.2.1";

import ProtectedRoute from "api/protectedRoute";
import ApplyUserSettings from 'hooks/useAuth';
import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import Logout from "layouts/Logout";
import PasswordReset from "layouts/PasswordReset";
import PasswordResetRequest from "layouts/PasswordResetRequest";
// import RTLLayout from "layouts/RTL.js";
import RegisterLayout from "layouts/Register.js";
import ServiceLayout from "layouts/Service.js";
import IndexView from "views/Index.js";
import InvoicePay from "views/pages/invoice/invoicePay";
import TermsLayout from "layouts/Terms.js"
import PrivacyLayout from "layouts/Privacy.js"

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <I18nProvider>
    <BrowserRouter>
      <ApplyUserSettings />
      <Routes>
        <Route path="/admin/*" element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        } />


        <Route path="/invoice/pay/:token" element={<InvoicePay />} />
        <Route path="/auth/*" element={<AuthLayout />} />
        <Route path="/service/*" element={<ServiceLayout />} />
        <Route path="/terms/*" element={<TermsLayout />} />
        <Route path="/privacy/*" element={<PrivacyLayout />} />
        <Route path="/register/*" element={<RegisterLayout />} />
        <Route path="/password-reset-request" element={<PasswordResetRequest />} />
        <Route path="/reset/:token" element={<PasswordReset />} />
        <Route path="/" element={<IndexView />} />
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/logout" element={<Logout />} />


      </Routes>
    </BrowserRouter>
  </I18nProvider>
);
